/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { createBiddingManagementAttachment } from 'store/modules/management_store/actions';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { ManagementState, ManagementTypes } from 'store/modules/management_store/types';
import { Container } from './styles';

interface AttachmentModalProps {
  attachmentModalOpened: boolean;
  setAttachmentModalOpened: React.Dispatch<React.SetStateAction<boolean>>;
  biddingId: number;
  referer: string;
}

interface FilesDescriptionTypes {
  [key: string]: string;
}

interface UploadProgressTypes {
  [key: string]: number;
}

const AttachmentModal = (props: AttachmentModalProps) => {
  const { attachmentModalOpened, setAttachmentModalOpened, biddingId, referer } = props;

  const dispatch = useDispatch();

  const { request_management_attachments } = useSelector<ApplicationState, ManagementState>(
    (state) => state.session.management,
  );

  const [fileList, setFileList] = useState<Array<File>>([]);
  const [filesDescription, setFilesDescription] = useState<FilesDescriptionTypes>({});
  const [inputFileText, setInputFileText] = useState<string>(
    'Clique para selecionar ou arraste os documentos aqui',
  );
  const [uploadProgress, setUploadProgress] = useState<UploadProgressTypes>({});

  const updateUploadProgress = (fileName: string, progress: number) => {
    setUploadProgress({
      ...uploadProgress,
      [`${fileName}`]: progress,
    });
  };

  const handleFile = async (event: any) => {
    await setFileList(Object.values(event.target.files));
  };

  const removeFile = (fileIndex: number) => {
    if (!fileList) return;

    const currentFile = Object.values(fileList)[fileIndex];
    setFileList(
      fileList.filter((file) => file.name !== currentFile.name || file.size !== currentFile.size),
    );
    const descriptionListCopy = filesDescription;
    delete descriptionListCopy[currentFile.name];
    setFilesDescription(descriptionListCopy);
  };

  const submitFiles = async (event: any) => {
    fileList.forEach((file) => {
      event.preventDefault();

      const formData = new FormData();
      formData.append('selectedFile', file);
      formData.append('biddingId', biddingId.toString());
      formData.append('referer', referer);
      formData.append('description', filesDescription[file.name] || '');
      dispatch(
        createBiddingManagementAttachment(
          formData,
          file.name,
          biddingId.toString(),
          updateUploadProgress,
        ),
      );
    });
  };

  useEffect(() => {
    dispatch({ type: ManagementTypes.UPDATE_CREATE_MANAGEMENT_ATTACHMENTS_STORE });
  }, []);

  useEffect(() => {
    let persistFileList: React.SetStateAction<File[]> = [];
    persistFileList = fileList.filter(
      (file) =>
        request_management_attachments?.create_management_attachements[file.name]?.loading ||
        (!request_management_attachments?.create_management_attachements[file.name]?.loading &&
          request_management_attachments?.create_management_attachements[file.name]?.error),
    );

    if (fileList.length === 0) return;

    const successfullyLoadedFilesCount = Object.values(
      request_management_attachments?.create_management_attachements,
    )
      .map((state) => state.loaded)
      .filter((state) => state).length;

    const attachedFilesCount = Object.values(
      request_management_attachments?.create_management_attachements,
    ).map((state) => state.loaded).length;

    if (successfullyLoadedFilesCount === attachedFilesCount)
      setTimeout(() => {
        setAttachmentModalOpened(false);
      }, 6000);

    setTimeout(() => {
      setFileList(persistFileList);
    }, 5000);
  }, [request_management_attachments?.create_management_attachements]);

  useEffect(() => {
    if (!fileList) return setInputFileText('Clique para selecionar ou arraste os documentos aqui');

    if (Object.values(fileList)?.length === 0)
      return setInputFileText('Clique para selecionar ou arraste os documentos aqui');

    return setInputFileText(`${Object.values(fileList)?.length} arquivos selecionados`);
  }, [fileList]);

  return (
    <Modal size="lg" show={attachmentModalOpened}>
      <Container>
        <div className="modal-header">
          <h5 className="modal-title">Adicionar anexo</h5>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => setAttachmentModalOpened(false)}
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="form-group form-group-color m-0 mt-3">
            <label className="my-0" htmlFor="file-upload label-modal">
              <div className="input-box">
                <i className="material-icons">file_upload</i>
                <span>{inputFileText}</span>
              </div>
              <input
                className="input-file"
                type="file"
                multiple
                id="file-upload"
                onChange={handleFile}
              />
            </label>
          </div>
          <div className="text-center">
            {fileList.length > 0 && (
              <button type="button" className="btn btn-link btn-sm" onClick={() => setFileList([])}>
                Limpar arquivos selecionados
              </button>
            )}
          </div>
          {fileList &&
            fileList.map((file, index) => (
              <div
                key={`${file.name}`}
                className={`card card-file border-0 p-2 mt-3 ${
                  request_management_attachments?.create_management_attachements[file.name] &&
                  request_management_attachments?.create_management_attachements[file.name]?.error
                    ? 'card-file-error'
                    : 'card-file'
                }
                    ${
                      request_management_attachments?.create_management_attachements[file.name] &&
                      request_management_attachments?.create_management_attachements[file.name]
                        ?.loading
                        ? 'card-file-loading'
                        : 'card-file'
                    }
                    `}
              >
                <div className="card-body p-1">
                  <div className="d-flex align-items-center mb-2">
                    <div className="mr-3">{file.name}</div>
                    {request_management_attachments?.create_management_attachements[file.name]
                      ?.loading && (
                      <div className="progress mt-2 ml-3">
                        <div
                          className="progress-bar progress-bar-striped bg-success"
                          role="progressbar"
                          style={{ width: `${uploadProgress[file.name]}%` || 0 }}
                          aria-valuenow={uploadProgress[file.name] || 0}
                          aria-valuemin={0}
                          aria-valuemax={100}
                        />
                        {uploadProgress[file.name] || ''}
                      </div>
                    )}
                    <button
                      type="button"
                      onClick={() => removeFile(index)}
                      className={`close ml-auto ${
                        request_management_attachments?.create_management_attachements[file.name] &&
                        request_management_attachments?.create_management_attachements[file.name]
                          ?.error
                          ? 'text-danger'
                          : 'text-secondary'
                      }
                      `}
                    >
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>
                  {request_management_attachments?.create_management_attachements[file.name] &&
                    request_management_attachments?.create_management_attachements[file.name]
                      ?.error && (
                      <div className="d-flex align-items-center mb-2">
                        <span className="material-icons alert-icon mr-1">error</span>
                        <span>Erro ao fazer upload do arquivo. Tente novamente</span>
                      </div>
                    )}
                  {request_management_attachments?.create_management_attachements[file.name] &&
                    request_management_attachments?.create_management_attachements[file.name]
                      ?.loaded && (
                      <div className="d-flex align-items-center mb-2">
                        <span className="material-icons alert-icon text-success mr-1">
                          check_circle
                        </span>{' '}
                        <span className="text-success">Upload realizado com sucesso!</span>
                      </div>
                    )}
                  <input
                    className="form-control"
                    id="description"
                    name="file-description"
                    type="text"
                    value={filesDescription[file.name] || ''}
                    onChange={(event) =>
                      setFilesDescription({
                        ...filesDescription,
                        [`${file.name}`]: event.target.value,
                      })
                    }
                    placeholder="Insira uma descrição para o documento (opcional)"
                  />
                </div>
              </div>
            ))}
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-primary" onClick={(event) => submitFiles(event)}>
            Adicionar anexo
          </button>
        </div>
      </Container>
    </Modal>
  );
};

export default AttachmentModal;
